import React, {Component} from 'react';
import StandardCRUD from "../../../components/StandardCRUD" //component that used for standard crud from

import data_field from './_field'; // fields form
import SidebarDataMaster from '../SidebarDataMaster';
import SectionDataView from '../../../containers/_layout/SectionDataView';


class Kategori extends Component {
  constructor(props) {
    super(props);

    this.options = {
      sortIndicator: true,
      hideSizePerPage: true,
      paginationSize: 6,
      hidePageListOnlyOnePage: true,
      clearSearch: true,
      alwaysShowAllBtns: false,
      withFirstAndLast: false
    }
    this.state = {
      reload:false,
      loading: false,
      id_pk_column: 'id',
      url: { url_get_data : '/telegram_user', url_save_data: '/telegram_user', url_update_data: '/telegram_user',
             url_delete_data: '/telegram_user', url_get_data_per: '/telegram_user' },
      title: 'Master Telegram User',
      title_add : 'Add Data Master Telegram User', 
      fields: data_field.data, 
      columns: [ 
        { header: 'Id Telegram', id: 'telegram_id', accessor: 'telegram_id', child_accessor: null, className: 'text-center'},
        { header: 'Nama User', id: 'nama', accessor: 'nama', child_accessor: null, className: 'text-center'},
        { header: 'Status', id: 'status', accessor: 'status', child_accessor: null,
            Cell: row => {
                return <span className={(row.value === 'AKTIF') ? 'badge badge-light' : 'badge badge-dark'}>{row.value}</span>
                }
        },
    ],
    }
  }

  render() {
    return (
      <React.Fragment>
          <SidebarDataMaster location={this.props.location.pathname}/>
          <StandardCRUD 
                columns={this.state.columns} 
                url={this.state.url} 
                title={this.state.title} 
                title_add={this.state.title_add} 
                fields={this.state.fields} 
                id_pk={null} 
                add_form={true}
                id_pk_column={this.state.id_pk_column}
                style_container="content content-components"
                search_query=""
                search_column={true}
          />
          <SectionDataView />
      </React.Fragment>
      
    );
  }
}

export default Kategori;
